import {NgModule} from '@angular/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {MatSelectModule} from '@angular/material/select';
import {MatIconModule} from '@angular/material/icon';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {SelectFilterComponent} from './select-filter.component';
import {MatToolbarModule} from '@angular/material/toolbar';
import {ContentModule} from '../../../shared/directives/content.module';
import {LoadingModule} from '../loading/loading.module';
import {IonicModule} from '@ionic/angular';
import {ModalModule} from '../modal/modal.module';
import {ContentModalModule} from '../../../shared/directives/content-modal.module';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatButtonModule} from '@angular/material/button';
import {ButtonModule} from '../../../modules/core/component/button/button.module';
import {KeepHtmlPipeModule} from '../../../modules/core/pipe/keep-html.pipe';

@NgModule({
    declarations: [
        SelectFilterComponent,
    ],
    exports: [
        SelectFilterComponent,
        ContentModule,
        ContentModalModule,
    ],
    imports: [
        ReactiveFormsModule,
        FormsModule,
        MatSelectModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatIconModule,
        NgxMatSelectSearchModule,
        MatSlideToggleModule,
        CommonModule,
        ContentModule,
        LoadingModule,
        IonicModule,
        ModalModule,
        MatGridListModule,
        MatButtonModule,
        ButtonModule,
        KeepHtmlPipeModule,
    ]
})
export class SelectFilterModule {}
